import { toPng, toBlob } from "html-to-image";

export type SocialCardFormat = "square" | "landscape" | "story";

export const FORMAT_DIMENSIONS: Record<SocialCardFormat, { width: number; height: number }> = {
  square: { width: 1080, height: 1080 },
  landscape: { width: 1920, height: 1080 },
  story: { width: 1080, height: 1920 },
};

export async function generateCardBlob(
  node: HTMLElement,
  format: SocialCardFormat,
): Promise<Blob> {
  const { width, height } = FORMAT_DIMENSIONS[format];
  const blob = await toBlob(node, {
    pixelRatio: 2,
    width,
    height,
    cacheBust: true,
  });
  if (!blob) throw new Error("html-to-image returned null blob");
  return blob;
}

export async function generateCardDataUrl(
  node: HTMLElement,
  format: SocialCardFormat,
): Promise<string> {
  const { width, height } = FORMAT_DIMENSIONS[format];
  return toPng(node, {
    pixelRatio: 2,
    width,
    height,
    cacheBust: true,
  });
}

/**
 * Write an image Blob to the clipboard.
 * Returns false on environments that don't support clipboard.write of image blobs.
 */
export async function copyImageToClipboard(blob: Blob): Promise<boolean> {
  try {
    if (
      typeof navigator === "undefined" ||
      !navigator.clipboard ||
      typeof ClipboardItem === "undefined"
    ) {
      return false;
    }
    const item = new ClipboardItem({ [blob.type]: blob });
    await navigator.clipboard.write([item]);
    return true;
  } catch {
    return false;
  }
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a short delay so the browser finishes the download
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
